import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { Profile } from 'src/app/model/profile';

import { AppState } from 'src/app/store/app.reducer';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { selectCurrentDevice, selectCurrentDeviceProfiles } from 'src/app/store/device/device.selector';


@Component({
    selector: 'app-device-profiles',
    templateUrl: './device-profiles.component.html',
    providers: [],
})
export class DeviceProfilesComponent implements OnInit, OnDestroy  {
	currentDeviceProfiles$: Observable<Profile[] | undefined>;
	currentDeviceProfilesSub: Subscription | undefined;

    profiles: Profile[];

    constructor(
        private store: Store<AppState>
    )  {
        this.initSelectors();
    }


    initSelectors(): void{
        // Store selectors
        this.currentDeviceProfiles$ = this.store.select(selectCurrentDeviceProfiles);
    }

    ngOnInit() {
        this.store.dispatch(DeviceActions.getProfiles());
        this.subscribeAll();
    }

    subscribeAll(): void {
        this.currentDeviceProfilesSub = this.currentDeviceProfiles$?.subscribe(
            (currentDeviceProfiles) => {
            this.profiles = currentDeviceProfiles;
            }
        );
    }

	ngOnDestroy(): void {
		this.currentDeviceProfilesSub?.unsubscribe();
	}
}
